import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ICalendarSubscriberFieldsFragment = {
  id?: any | null
  projectId: any
  subscriberCode?: string | null
  privateCode?: string | null
  calendarSubscriberType?: Types.CalendarSubscriberType | null
}

export type IGetCalendarSubscribersQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IGetCalendarSubscribersQuery = {
  calendarSubscribers?: {
    data: Array<{
      id?: any | null
      projectId: any
      subscriberCode?: string | null
      privateCode?: string | null
      calendarSubscriberType?: Types.CalendarSubscriberType | null
    }>
  } | null
}

export type IInviteCalendarSubscriberMutationVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  subscriberCode: Types.Scalars['String']['input']
}>

export type IInviteCalendarSubscriberMutation = {
  inviteCalendarSubscriber?: {
    id?: any | null
    projectId: any
    subscriberCode?: string | null
    privateCode?: string | null
    calendarSubscriberType?: Types.CalendarSubscriberType | null
  } | null
}

export type IDeleteCalendarSubscriberMutationVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IDeleteCalendarSubscriberMutation = {
  deleteCalendarSubscriber?: boolean | null
}

export type IGenerateSubscriberForExternalCalendarsMutationVariables =
  Types.Exact<{ [key: string]: never }>

export type IGenerateSubscriberForExternalCalendarsMutation = {
  generateSubscriberForExternalCalendars?: {
    id?: any | null
    projectId: any
    subscriberCode?: string | null
    privateCode?: string | null
    calendarSubscriberType?: Types.CalendarSubscriberType | null
  } | null
}

export const CalendarSubscriberFieldsFragmentDoc = gql`
  fragment CalendarSubscriberFields on CalendarSubscriber {
    id
    projectId
    subscriberCode
    privateCode
    calendarSubscriberType
  }
`
export const GetCalendarSubscribersDocument = gql`
  query GetCalendarSubscribers($projectId: ObjectId!) {
    calendarSubscribers(projectId: $projectId) {
      data {
        ...CalendarSubscriberFields
      }
    }
  }
  ${CalendarSubscriberFieldsFragmentDoc}
`

/**
 * __useGetCalendarSubscribersQuery__
 *
 * To run a query within a React component, call `useGetCalendarSubscribersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarSubscribersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarSubscribersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCalendarSubscribersQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetCalendarSubscribersQuery,
    IGetCalendarSubscribersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetCalendarSubscribersQuery,
    IGetCalendarSubscribersQueryVariables
  >(GetCalendarSubscribersDocument, options)
}
export function useGetCalendarSubscribersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetCalendarSubscribersQuery,
    IGetCalendarSubscribersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetCalendarSubscribersQuery,
    IGetCalendarSubscribersQueryVariables
  >(GetCalendarSubscribersDocument, options)
}
export type GetCalendarSubscribersQueryHookResult = ReturnType<
  typeof useGetCalendarSubscribersQuery
>
export type GetCalendarSubscribersLazyQueryHookResult = ReturnType<
  typeof useGetCalendarSubscribersLazyQuery
>
export type GetCalendarSubscribersQueryResult = Apollo.QueryResult<
  IGetCalendarSubscribersQuery,
  IGetCalendarSubscribersQueryVariables
>
export const InviteCalendarSubscriberDocument = gql`
  mutation InviteCalendarSubscriber(
    $projectId: ObjectId!
    $subscriberCode: String!
  ) {
    inviteCalendarSubscriber(
      projectId: $projectId
      subscriberCode: $subscriberCode
    ) {
      ...CalendarSubscriberFields
    }
  }
  ${CalendarSubscriberFieldsFragmentDoc}
`
export type IInviteCalendarSubscriberMutationFn = Apollo.MutationFunction<
  IInviteCalendarSubscriberMutation,
  IInviteCalendarSubscriberMutationVariables
>

/**
 * __useInviteCalendarSubscriberMutation__
 *
 * To run a mutation, you first call `useInviteCalendarSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCalendarSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCalendarSubscriberMutation, { data, loading, error }] = useInviteCalendarSubscriberMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      subscriberCode: // value for 'subscriberCode'
 *   },
 * });
 */
export function useInviteCalendarSubscriberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IInviteCalendarSubscriberMutation,
    IInviteCalendarSubscriberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IInviteCalendarSubscriberMutation,
    IInviteCalendarSubscriberMutationVariables
  >(InviteCalendarSubscriberDocument, options)
}
export type InviteCalendarSubscriberMutationHookResult = ReturnType<
  typeof useInviteCalendarSubscriberMutation
>
export type InviteCalendarSubscriberMutationResult =
  Apollo.MutationResult<IInviteCalendarSubscriberMutation>
export type InviteCalendarSubscriberMutationOptions =
  Apollo.BaseMutationOptions<
    IInviteCalendarSubscriberMutation,
    IInviteCalendarSubscriberMutationVariables
  >
export const DeleteCalendarSubscriberDocument = gql`
  mutation DeleteCalendarSubscriber($id: ObjectId!) {
    deleteCalendarSubscriber(id: $id)
  }
`
export type IDeleteCalendarSubscriberMutationFn = Apollo.MutationFunction<
  IDeleteCalendarSubscriberMutation,
  IDeleteCalendarSubscriberMutationVariables
>

/**
 * __useDeleteCalendarSubscriberMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarSubscriberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarSubscriberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCalendarSubscriberMutation, { data, loading, error }] = useDeleteCalendarSubscriberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarSubscriberMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteCalendarSubscriberMutation,
    IDeleteCalendarSubscriberMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteCalendarSubscriberMutation,
    IDeleteCalendarSubscriberMutationVariables
  >(DeleteCalendarSubscriberDocument, options)
}
export type DeleteCalendarSubscriberMutationHookResult = ReturnType<
  typeof useDeleteCalendarSubscriberMutation
>
export type DeleteCalendarSubscriberMutationResult =
  Apollo.MutationResult<IDeleteCalendarSubscriberMutation>
export type DeleteCalendarSubscriberMutationOptions =
  Apollo.BaseMutationOptions<
    IDeleteCalendarSubscriberMutation,
    IDeleteCalendarSubscriberMutationVariables
  >
export const GenerateSubscriberForExternalCalendarsDocument = gql`
  mutation GenerateSubscriberForExternalCalendars {
    generateSubscriberForExternalCalendars {
      ...CalendarSubscriberFields
    }
  }
  ${CalendarSubscriberFieldsFragmentDoc}
`
export type IGenerateSubscriberForExternalCalendarsMutationFn =
  Apollo.MutationFunction<
    IGenerateSubscriberForExternalCalendarsMutation,
    IGenerateSubscriberForExternalCalendarsMutationVariables
  >

/**
 * __useGenerateSubscriberForExternalCalendarsMutation__
 *
 * To run a mutation, you first call `useGenerateSubscriberForExternalCalendarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSubscriberForExternalCalendarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSubscriberForExternalCalendarsMutation, { data, loading, error }] = useGenerateSubscriberForExternalCalendarsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateSubscriberForExternalCalendarsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IGenerateSubscriberForExternalCalendarsMutation,
    IGenerateSubscriberForExternalCalendarsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IGenerateSubscriberForExternalCalendarsMutation,
    IGenerateSubscriberForExternalCalendarsMutationVariables
  >(GenerateSubscriberForExternalCalendarsDocument, options)
}
export type GenerateSubscriberForExternalCalendarsMutationHookResult =
  ReturnType<typeof useGenerateSubscriberForExternalCalendarsMutation>
export type GenerateSubscriberForExternalCalendarsMutationResult =
  Apollo.MutationResult<IGenerateSubscriberForExternalCalendarsMutation>
export type GenerateSubscriberForExternalCalendarsMutationOptions =
  Apollo.BaseMutationOptions<
    IGenerateSubscriberForExternalCalendarsMutation,
    IGenerateSubscriberForExternalCalendarsMutationVariables
  >
